import {osmApiUrl} from "../../app/read_rp_environment_variables";

export const OSMPoiRoutesUrl = `${osmApiUrl}/geo-assets/poi/routes/`;
import {osmApiUrl} from "../../app/read_rp_environment_variables";

export const OSMPoiRoutesUrl = `${osmApiUrl}/geo-assets/poi/routes/`;
